import BaseStore from '@src/utils/store/base-store';
import SidebarContainerStore from '@src/components/sidebar-container/store';
import useMount from '@src/utils/hooks/use-mount';
import { noop } from '@src/utils/common-util';
import $$tracker from '@src/tracker';
import { useEffect } from 'react';

import { observable } from 'mobx';
class SideBarStore extends BaseStore {
  sidebarContainerStore = new SidebarContainerStore();

  changeMenu = noop;

  navList = [
    { type: '首页', index: 0 },
    { type: '活动特色', index: 1 },
    { type: '网页活动', index: 2 },
    { type: '抽奖活动', index: 3 },
    { type: '角色情报', index: 4 },
    { type: '游戏特色', index: 5 },
    { type: '关注我们', index: 6 }
  ];

  @observable currentIndex = 0;

  close() {
    this.sidebarContainerStore.isActive = false;
  }

  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  use() {
    super.use();
    useEffect(() => {
      $$tracker.exposePage(String(this.currentIndex));
    }, [this.currentIndex]);
    useMount(() => {
      // this.sidebarContainerStore.isActive = true;
    });
  }
}

export default SideBarStore;
